"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var MessageThreadSubjectTypeEnum;
(function (MessageThreadSubjectTypeEnum) {
    MessageThreadSubjectTypeEnum["PERSONAL"] = "personal";
    MessageThreadSubjectTypeEnum["LIVECHAT"] = "livechat";
    MessageThreadSubjectTypeEnum["BROADCAST_MEMBER"] = "broadcast_member";
    MessageThreadSubjectTypeEnum["BROADCAST_CREATOR"] = "broadcast_creator";
})(MessageThreadSubjectTypeEnum = exports.MessageThreadSubjectTypeEnum || (exports.MessageThreadSubjectTypeEnum = {}));
class MessageThreadsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            MessageThread: () => `
        ... on MessageThread {
          id
          createdTime
          lastMessageId
          lastMessage {
            ${this.getFragment("Message")}
          }
          unreadMessageCount
          minUnreadMessageId
          memberTotalSpent
          updatedTime
          pinTime
          subject {
            ${this.getFragment("Subject")}
          }
          userIds
          users {
            ${this.getFragment("UserPublicData")}
          }
        }
      `,
        };
    }
    find({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query MessageThreadsFind($data: InputMessageThreadSearch!) {
          messageThreadsFind(data: $data) {
            result {
              ${this.getFragment("MessageThread")}
            }
            hasNextPage
            hasPrevPage
            page
            size
            totalPages
            totalRecords
          }
        }
      `,
                variables: { data },
            });
            return response.data.messageThreadsFind;
        });
    }
    findPersonal({ opponentId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query MessageThreadsFindPersonal($opponentId: ID!) {
          messageThreadFindPersonal(opponentId: $opponentId) {
            ${this.getFragment("MessageThread")}
          }
        }
      `,
                variables: { opponentId },
            });
            return response.data.messageThreadFindPersonal;
        });
    }
    getUnreadCount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("messageThreadsGetUnreadCount");
        });
    }
    markRead({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("messageThreadsMarkRead", { data });
        });
    }
    togglePin({ threadId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("messageThreadsTogglePin", { threadId });
        });
    }
}
exports.MessageThreadsProvider = MessageThreadsProvider;
//# sourceMappingURL=MessageThreadsProvider.js.map